export const getFontesEnergia = (state) => state.fontesEnergia.lista
export const getIsCarregandoListaFontesEnergia = (state) => state.fontesEnergia.isCarregandoLista
export const getIsSavingFontesEnergia = (state) => state.fontesEnergia.isSaving
export const getIsUpdatingFontesEnergia = (state) => state.fontesEnergia.isUpdate
